import useReveal from "../shared/useReveal";
import "./TestimonialsHome.css";
import "./HomeSections.css";

const TESTIMONIALS = [
  {
    quote:
      "My portfolio review opened my eyes — I was holding 14 overlapping funds. We consolidated to 6, and my returns and peace of mind both improved.",
    name: "R. Sharma",
    role: "Salaried Investor · Portfolio Review",
  },
  {
    quote:
      "From company registration to our first ₹3 Cr bank loan, the same team handled everything. The CMA data and project report work was flawless.",
    name: "A. Jain",
    role: "Manufacturing SME · Business Client",
  },
  {
    quote:
      "Goal-based planning changed how our family invests. Every SIP now has a purpose, and the quarterly review calls keep us disciplined.",
    name: "P. & S. Agarwal",
    role: "Wealth Management Clients",
  },
  {
    quote:
      "Clear, research-backed IPO advice — including telling me when NOT to apply. That honesty is rare.",
    name: "V. Mehta",
    role: "Retail Investor · IPO Advisory",
  },
];

export default function TestimonialsHome() {
  const ref = useReveal();

  return (
    <section className="section" id="testimonials">
      <div className="container" ref={ref}>
        <div className="home-section-head section-head pm-reveal">
          <span className="kicker">Client Stories</span>
          <h2>Trusted by families and founders alike</h2>
        </div>
        <div className="home-testi-grid pm-stagger">
          {TESTIMONIALS.map((t) => (
            <div className="home-testi pm-reveal" key={t.name}>
              <div className="home-starrow">★★★★★</div>
              <p>&ldquo;{t.quote}&rdquo;</p>
              <footer>
                <b>{t.name}</b>
                <span>{t.role}</span>
              </footer>
            </div>
          ))}
        </div>
        <div className="home-rating-strip pm-reveal">
          <span>
            ⭐ <b>4.9/5</b> Google Rating
          </span>
          <span>
            👥 <b className="num">1,500+</b> happy clients
          </span>
          <span>🏅 AMFI-registered distribution</span>
          <span>🎓 CFA · CA · CS certified team</span>
        </div>
      </div>
    </section>
  );
}
